import { contactPersonSectionValidationMap } from 'mittweida/inquiry/steps/userProfile/sections/contactPerson/fieldValidations';

export const mittweidaContactPersonFieldValidation = {
  ...contactPersonSectionValidationMap,
};
